module.exports = __webpack_public_path__ + "static/media/bangalore-rmc.47664b64.png";